import {propsType} from "./Toktokquiz-ver2";


export default function NplaceSave(props: propsType) {
    return <>NplaceSave</>
}